export const CHECKOUT_CHARGE_PAYMENT_TYPE = {
  debitCard: 'debitCard',
  cashApp: 'cashApp',
  bonuses: 'bonuses',
  paypalPYUSD: 'paypalPYUSD'
}
